// extracted by mini-css-extract-plugin
export default {"cls1":"Modal-cls1_qmD","cls2":"Modal-cls2_F7f Modal-cls1_qmD"};